import Modal from "react-modal";
import React, {useEffect, useState} from "react";
import './Variz.css'
import axios from "axios";
import {useMediaQuery} from "beautiful-react-hooks";
import Select, {components} from 'react-select';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { MdContentCopy } from "react-icons/md";
import SelectAsyncPaginate from "./SelectAsyncPaginate";
import Toast from "./Tost";
import {toast} from "react-toastify";












export default function ({modalIsOpen,Openchanger,coinSelected='BTC',coinChanger}){

    const [amount,setamount] = useState('')
    const { SingleValue, Option } = components;


    let phone = sessionStorage.getItem('user')
    const isSmall = useMediaQuery('(max-width: 1000px)')
    const [isCopied, setIsCopied] = useState(false);
    const [options,setOptions] = useState([])
    const [DepositAddresses,setDepositAddresses] = useState()
    const [loading,setLoading] = useState(false)
    const[textId,setTextId] = useState('')
    const [type,setType] = useState('')

    const [coins, setCoins] = useState({label:'',value:coinSelected,image:`https://static.sinatether.com/CoinsImg/${coinSelected}.png`});
    const [currentChain, setcurrentChain] = useState(null);
    const [message,setMessage] = useState('')

        const onchangeSelect = (item) => {
          setcurrentChain(null);
          setCoins(item);
       };



      const onCopyText = () => {
                 setIsCopied(true);
                 setTimeout(() => {
                 setIsCopied(false);

                     }, 1000);
         };




    const customStylesDesktop = {
        overlay: {
      position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(0,0,0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',


    },

          content: {
           background: '#ffffff',
                  width: '60rem',
                  maxWidth: 'calc(150vw - 2rem)',
                  maxHeight: 'calc(100vh - 2rem)',
                  border:'0px',
                  overflowY: 'auto',
                  position: 'relative',
                  borderRadius: '0.8rem',
              inset: '9px'




          },


};


    const customStylesMobile = {
        overlay: {
      position: 'fixed',
                  zIndex: 1020,
                  top: 0,
                  left: 0,
                  width: '100vw',
                  height: '100vh',
                  background: 'rgba(0,0,0, 0.5)',
                  display: 'flex',
                  justifyContent: 'center',


    },

          content: {
           background: '#ffffff',
                  width: '34rem',
                  maxWidth: 'calc(150vw - 2rem)',
                  maxHeight: 'calc(95vh - 1rem)',
                  overflowY: 'auto',
                  border:'0px',
                  position: 'relative',
                  borderRadius: '0.4rem',
                  inset:'0px',
                  margin : '0vh 0px 0px 0px',



          },


};


    useEffect(async ()=>{

        await axios.get('https://api.sinatether.com/Auth/GetCurrencies/').then((res)=>{
            if(res.status == 200)
            {
                setOptions(res.data['curr'])
                for (let i=0;i<res.data['curr'].length;i++){



                     if (res.data['curr'][i].value == coinSelected ){




                         setCoins(res.data['curr'][i])

                       //  findCoinSelected(options[i].value,coinBy.value)
                         break;
                     }

                 }



            }
        })


    },[])



    useEffect(()=>{

    },[DepositAddresses])







const IconSingleValue2 = (props) => (
    <SingleValue {...props}>
        <img src={props.data.image} style={{ height: '30px', width: '30px', borderRadius: '50%', marginRight: '10px' }} alt=""/>
        <span className={'text-large pl-1'}>{props.data.label}</span>
    </SingleValue>
);

const IconOption2 = (props) => (
    <Option {...props}>
        <img src={props.data.image} style={{ height: '30px', width: '30px', borderRadius: '50%', marginRight: '10px' }} alt=""/>
        <span className={'text-large pl-1'}>{props.data.label}</span>
    </Option>
);

const customStyles = {

    control: (provided) => ({
        ...provided,
        backgroundColor: '#F0F0F0',
        borderRadius:'12px',
        height:'40px'



  }),

    option: (provided,{isFocused,isSelected}) => ({
        ...provided,
        backgroundColor:'#F0F0F0',
        color:'white',
         background: isFocused
        ? '#e0dfe3'
        : isSelected
            ? '#e0dfe3'
            : undefined,
    zIndex: 1,

    }),
    singleValue: (provided,{isFocused}) => ({
        ...provided,
        backgroundColor:'#F0F0F0',
        borderRadius:'12px',
        borderColor: isFocused ? '#2DBD96' : '#2DBD96'


    }),
}







    Modal.setAppElement('#root');




    let subtitle;
    function afterOpenModal() {
  }
   function closeModal() {
       coinChanger('')
        Openchanger(false)

  }










    function handelpayment(){
        const id = toast.loading("درحال پردازش درخواست واریزی شما...")

        axios.post('https://api.sinatether.com/Auth/GetHistDeposit/',{
            'curr': coins['value'],'txId':textId, 'phone': phone},{withCredentials:true}).then((res)=>{
                      if (res.status == 200){
                             if(res.data['status'] == 200){
                                toast.update(id, { render: res.data['message'], type: "success", isLoading: false });
                                 setTimeout(() => {
                                    window.location.replace('/')
                                }, 1500)
                     }else {
                                toast.update(id, { render: res.data['message'], type: "error", isLoading: false });

                                

                         }
            }



        }).catch((error)=> {
            if (error) {
                if (error.response.status === 400){
                    toast.dismiss()
                    toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                }else{
                toast.dismiss()

                toast.error('فرایند به طور کامل انجام نشد مجددا امتحان کنید')
                }
            }
        })
    }


    let num;

    function handelchange(event){

        let  n =event.target.value
          setTextId(n)
        /*console.log(n)
        n=n.replace(/\,/g,'')
        n=Number(n)
        //let a= new Intl.NumberFormat("fa").format(n)
        document.getElementById('amount').value = new Intl.NumberFormat("fa").format(n)*/

    }







    function separateNum(event) {
        let value = event.target.value
        var nStr = value + '';
        nStr = nStr.replace(/\,/g, "");
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        if (event !== undefined) {
            event.target.value = x1 + x2;
            ex_normalNum(event.target.value)
        } else {
            return x1 + x2;
        }
    }



    function ex_normalNum(num) {
            num = num.replace(/,\s?/g, "");
            setamount(num);
            console.log(amount)
        }



     function Gotolist() {
         window.location.replace('/HistVarizCoins')
     }








  return(
      <>
          <Toast type={type} message={message}/>

      {isSmall ?
              <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    ariaHideApp={false}
                    style={customStylesMobile}
                    contentLabel="Example Modal"
                    backdrop= "static"

                  >

                      <div className={'container'} id={'mbody'}>
                          <div className={'title'}>
                              <span className="close" onClick={closeModal}>&times;</span>
                              <h5 className="myheav">واریز ارز</h5>
                              <hr/>


                          </div>

                          <div className={'row'}>

                                  <form className={'col-md-7'}>
                                      {loading ?
                                          <>
                                              <i className="fa fa-spinner fa-spin"></i>
                                          </>


                                          :
                                          <>


                                              <label className={'text-medium'}>انتخاب ارز:</label>
                                           <Select
                                                  value={coins}
                                                  onChange={onchangeSelect}
                                                  options={options}
                                                  getOptionValue={(option) => option.value}
                                                  getOptionLabel={(option) => option.label}
                                                  styles={customStyles}

                                                  components={{
                                                      SingleValue: IconSingleValue2,
                                                      Option: IconOption2
                                                  }}
                                                  />
                                              <label className={'text-medium pt-2'}>انتخاب شبکه:</label>
                                               <SelectAsyncPaginate
                                                 styles={customStyles}
                                                 coinName={coins['value']}
                                                 value={currentChain}
                                                 onChange={(coin) => setcurrentChain(coin)}
                                                 getDeposit={setDepositAddresses}
                                                 type = {"deposit"}

                                                />

                                              {DepositAddresses ?
                                                  <div className={'w-100 pt-2'}>
                                                    {coins && currentChain ?
                                                     <>

                                                      <span className={'text-sR text-medium'}>
                                                      برای واریز 
                                                      <span className="pr-1 pl-1">{coins['value']}</span>
                                                      ی خود در شبکه 
                                                      <span className="pr-1 pr-1">{currentChain['value']}</span>
                                                       از آدرس زیر استفاده کنید.
                                                       </span>
                                                       

                                                      <div className={'w-100 '}>
                                                          <CopyToClipboard text={DepositAddresses['address']} onCopy={onCopyText}>
                                                              <span className={'text-medium text-dark'}>{isCopied ? "کپی شد!" : <MdContentCopy/>}</span>
                                                          </CopyToClipboard>
                                                          <input
                                                              className={'myinput_form text-center w-100 text-medium txIdMemo bg-custom-input mytext-warning '}
                                                              value={DepositAddresses['address']} readOnly={true}/>

                                                      </div>

                                                      {DepositAddresses['memo'] ?
                                                          <>
                                                              <span className={'text-sR text-medium '}>حتماً دقت نمایید که برای واریز به این آدرس، از مقدار «تگ» زیر استفاده کنید. در غیر این صورت مبلغ برای حساب شما محسوب نمی‌شود.</span>


                                                              <div className={'w-100  '}>
                                                                  <CopyToClipboard text={DepositAddresses['memo']}
                                                                                   onCopy={onCopyText}>
                                                                      <span className={'text-medium'}>{isCopied ? "کپی شد!" :
                                                                          <MdContentCopy/>}</span>
                                                                  </CopyToClipboard>
                                                                  <div className={'text-center'}>


                                                                      <input
                                                                          className={'myinput_form text-center w-100 text-medium txIdMemo bg-custom-input mytext-warning '}
                                                                          value={DepositAddresses['memo']} readOnly={true}/>
                                                                  </div>


                                                              </div>
                                                          </>

                                                          :
                                                          <></>
                                                      }


                                                    </>
                                                    :
                                                      <></>
                                                   }


                                                  </div>
                                                  :
                                                  <></>
                                              }
                                          </>


                                      }


                    <div className={'w-100 pt-2'}>
                                  <label className={'text-medium'}>کدتراکنش(txId):</label>

                                  <input className={'myinput_form text-center w-100 text-large bg-custom-input  border myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6'} dir={'ltr'} onChange={handelchange}/>

                              </div>


                    <div className={'text-left btnvariz pb-2 '}>
                             <br/>

                            
                             <button type={'button'} className={'btn  btn-success py-2 btsubmit2020'} data-inline={true} onClick={handelpayment}>ثبت واریز</button>

                         </div>



                                  </form>

                              <form className={'col-md-5  pt-2'}>
                              <div className={'lfjdifhdfj6626 '}>
                            <div className={'title_warning fhyfgeyrberh200'}>
                                <div className={' mytext-warning text-center  '}>

                                <span className={'mytext-warning text-center text-large mytit981222 '}>مراحل واریز ارز</span>
                                </div>

                                <div className={' mt-2 pl-1'}>

                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                    جهت واریز رمزارز به حساب کاربری خود ابتدا نام رمزارز و شبکه انتقال را انتخاب کنید و سپس ارز خود را به آدرس دریافتی واریز کنید.
                            

                                    </span>

                                </div>
                                <div className={'mt-2 pl-1'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                    پس از انجام تراکنش کد تراکنش (txid) خود را ثبت کنید.
                                                                        </span>

                                </div>



                                 <div className={'mt-2 pl-1 pb-2'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                    <>در صورت عدم ثبت کدتراکنش مبلغ واریزی در حساب شما منظور نخواهد شد.</>


                                    </span>

                                </div>
                            </div>
                            <div>

                            </div>

                        </div>

                                    


                                      <div className="card-tazakor">

<div>
   <div className="tewxtushe63">توجه !</div>
   در صورت واریز ارز تقلبی با اسم و نماد مشابه با ارز های موجود در سایت و با شماره قرارداد هوشمند متفاوت از سوی کاربر، ارز واریز شده از دسترس کاربر خارج خواهد شد.

             </div>

</div>

                              </form>
                              

                          </div>




                      </div>




                  </Modal>

              :
                  <Modal
                    isOpen={modalIsOpen}
                    onAfterOpen={afterOpenModal}
                    ariaHideApp={false}
                    style={customStylesDesktop}
                    contentLabel="Example Modal"
                    backdrop= "static"

                  >

                      <div className={'container'} id={'mbody'}>
                          <div className={'title'}>
                              <span className="close" onClick={closeModal}>&times;</span>
                          


                          </div>

                          <div className={'row'}>

                                  <form className={'col-md-7 card820820 jeiurguyegu66'}>
                                    <div className="kfhdfgeerettetete">

                                  <div className="titledesl820">واریز ارز </div>

                                      {loading ?
                                          <>
                                              <i className="fa fa-spinner fa-spin"></i>
                                          </>


                                          :
                                          <>


                                              <label className={'text-large'}>انتخاب ارز:</label>
                                           <Select
                                                  value={coins}
                                                  onChange={onchangeSelect}
                                                  options={options}
                                                  getOptionValue={(option) => option.value}
                                                  getOptionLabel={(option) => option.label}
                                                  styles={customStyles}

                                                  components={{
                                                      SingleValue: IconSingleValue2,
                                                      Option: IconOption2
                                                  }}
                                                  />
                                              <label className={'text-large pt-2'}>انتخاب شبکه:</label>
                                               <SelectAsyncPaginate
                                                   styles={customStyles}
                                                   coinName={coins['value']}
                                                   value={currentChain}
                                                   onChange={(chain) => setcurrentChain(chain)}
                                                   getDeposit={setDepositAddresses}
                                                   type={"deposit"}
                                                />


                                              <br/>
                                              {DepositAddresses ?
                                                  <div className={'w-100'}>
                                                    {coins && currentChain ?
                                                    <>
                                                      <span className={'text-sR text-medium'}>
                                                      برای واریز 
                                                      <span className="pr-1 pl-1">{coins['value']}</span>
                                                      ی خود در شبکه 
                                                      <span className="pr-1 pr-1">{currentChain['value']}</span>
                                                       از آدرس زیر استفاده کنید.
                                                       </span>
                                                       
                                                       

                                                          
                                                      <div className={'w-100 '}>
                                                          <CopyToClipboard text={DepositAddresses['address']} onCopy={onCopyText}>
                                                              <span>{isCopied ? "کپی شد!" : <MdContentCopy/>}</span>
                                                          </CopyToClipboard>
                                                          <input
                                                              className={'myinput_form text-center w-100 text-large txIdMemo  bg-custom-input mytext-warning '}
                                                              value={DepositAddresses['address']} readOnly={true}/>

                                                      </div>
                                                      

                                                      {DepositAddresses['memo'] ?
                                                          <>
                                                              <span className={'text-sR text-medium '}>حتماً دقت نمایید که برای واریز به این آدرس، از مقدار «تگ» زیر استفاده کنید. در غیر این صورت مبلغ برای حساب شما محسوب نمی‌شود.</span>


                                                              <div className={'w-100  '}>
                                                                  <CopyToClipboard text={DepositAddresses['memo']}
                                                                                   onCopy={onCopyText}>
                                                                      <span>{isCopied ? "کپی شد!" :
                                                                          <MdContentCopy/>}</span>
                                                                  </CopyToClipboard>
                                                                  <div className={'text-center'}>


                                                                      <input
                                                                          className={'myinput_form text-center w-100 text-large txIdMemo bg-custom-input mytext-warning'}
                                                                          value={DepositAddresses['memo']} readOnly={true}/>
                                                                  </div>


                                                              </div>
                                                          </>

                                                          :
                                                          <></>
                                                      }

</>
                                                      :
                                                      <></>
                                                   }


                                                  </div>
                                                  :
                                                  <></>
                                              }
                                          </>


                                      }


                                <div className={'w-100 pt-2'}>

                                  <label className={'text-large text-dark'}>کدتراکنش(txId):</label>

                                  <input className={'myinput_form text-center w-100 text-large bg-custom-input border myinput_form w-100  border bg-custom-input input-order667 input-order667 magg6  '} dir={'ltr'} onChange={handelchange}/>

                              </div>


                              </div>


                              <div className={'text-left btnvariz '}>
                                  <br/>

                             <button type={"button"} className={'btn  btn-success py-2 btsubmit2020  '} data-inline={true} onClick={handelpayment}>ثبت واریز</button>

                                </div>



                                  </form>

                              <form className={'col-5'}>
                                  <div className={'border-dark'}>



                                    
                        <div className={'lfjdifhdfj6626 '}>
                            <div className={'title_warning fhyfgeyrberh200'}>
                                <div className={' mytext-warning text-center  '}>

                                <span className={'mytext-warning text-center text-large mytit981222 '}>مراحل واریز ارز</span>
                                </div>

                                <div className={' mt-2 pl-1'}>

                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                    جهت واریز رمزارز به حساب کاربری خود ابتدا نام رمزارز و شبکه انتقال را انتخاب کنید و سپس ارز خود را به آدرس دریافتی واریز کنید.
                            

                                    </span>

                                </div>
                                <div className={'mt-2 pl-1'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>

                                    پس از انجام تراکنش کد تراکنش (txid) خود را ثبت کنید.
                                                                        </span>

                                </div>



                                 <div className={'mt-2 pl-1 pb-2'}>
                                    <span className={' text-large'}>
                                    <img className="mytext-warning item_balance" src="./images/tik.png" alt=""/>
                                    <>در صورت عدم ثبت کدتراکنش مبلغ واریزی در حساب شما منظور نخواهد شد.</>


                                    </span>

                                </div>
                            </div>
                            <div>

                            </div>

                        </div>

                                    


                                      <div className="card-tazakor htyfygyf43657688123">

<div>
   <div className="tewxtushe63">توجه !</div>
   در صورت واریز ارز تقلبی با اسم و نماد مشابه با ارز های موجود در سایت و با شماره قرارداد هوشمند متفاوت از سوی کاربر، ارز واریز شده از دسترس کاربر خارج خواهد شد.

             </div>

</div>

                                      
                                  </div>

                              </form>
                              

                          </div>


                         

                      </div>




                  </Modal>
      }
            </>


  )
}